import React, { useState, useEffect } from 'react';
import ProjectCard from '../ProjectCard';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import './projectGallery.css'

import { getProjectsByLevelAndUser } from '../../../Datahandler';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';


const ProjectGallery = () => {
  const currentUser = useSelector(state => state.user.loggedInUser);

  const [projects, setProjects] = useState([])
  const location = useLocation();

  useEffect(() => {
    if (currentUser) {
        getProjectsByLevelAndUser(currentUser.level, currentUser.userId, location.pathname.split("/")[2]).then((res) => {
          setProjects(res);
        });
      } else {
      // No user is logged in, fetch all projects
      getProjectsByLevelAndUser(0, null).then((res) => {
        setProjects(res);
      });
    }
  }, [currentUser, location.pathname]);


  return (


    <><Row className='gallery-container'>
      {Object.values(projects).map(project => (
        <Col key={'col' + project.uid + crypto.randomUUID()} xs={12} md={3} style={{ display: 'flex', flexWrap: 'wrap' }}>
          <ProjectCard
            key={project.uid}
            image={project.imgUrl}
            title={project.title}
            description={project.description} />
        </Col>
      ))}
    </Row>
      <Row className='gallery-container'>
        <Col xs={12} md={4} style={{ textAlign: 'right' }}>
          <img alt="riot ppl"
            class="project-image"
            src="https://firebasestorage.googleapis.com/v0/b/riotlabs-web.appspot.com/o/images%2Friot-proj-ppl.png?alt=media&token=4e227746-1c19-4e5a-b51e-fd5c7e274b81&_gl=1*dnu8ju*_ga*NzMzMjg4ODE4LjE2NzQ4MjM4MzM.*_ga_CW55HF8NVT*MTY4NTgzMDg1NS4xMS4xLjE2ODU4MzA4ODMuMC4wLjA." />
        </Col>
      </Row>
    </>


  );
};

export default ProjectGallery;
